/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aptos_Chain_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "BlockMetadata, StateCheckpoint, Validator, Genesis" |
*
* @param {Aptos_Chain_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const aptos_chain_tps_explanation = /** @type {((inputs?: Aptos_Chain_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aptos_Chain_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("BlockMetadata, StateCheckpoint, Validator, Genesis")
});